import React from 'react'
import { GeneratedPosts, MainLayout } from '../components'

export const GeneratedPostsPage: React.FC = () => {
	return (
		<div className='generated-posts-page'>
			<MainLayout>
				<GeneratedPosts />
			</MainLayout>
		</div>
	)
}
